import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API from "./config/API";

const Login = () => {
  const navigate = useNavigate();

  const [emailId, setEmailId] = useState("");
  const [password, setPassword] = useState("");
  const [roleType, setRoleType] = useState("PG_OWNER");

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // ==========================================
  // LOGIN ROLES
  // ==========================================

  const roles = [
    {
      value: "PG_OWNER",
      label: "PG Owner",
    },
    // {
    //   value: "APP_ADMIN",
    //   label: "App Admin",
    // },
    {
      value: "APP_EXECUTOR",
      label: "App Executor",
    },
    {
      value: "USER",
      label: "User",
    },
  ];

  // ==========================================
  // LOGIN
  // ==========================================

  const handleLogin = async (e) => {
    e.preventDefault();

    setErrorMessage("");
    setSuccessMessage("");

    // ==========================================
    // VALIDATION
    // ==========================================

    if (!emailId.trim()) {
      setErrorMessage("Please enter your email");
      return;
    }

    if (!password) {
      setErrorMessage("Please enter your password");
      return;
    }

    try {
      setLoading(true);

      // ==========================================
      // LOGIN REQUEST
      // ==========================================

      const request = {
        emailId: emailId.trim(),
        password: password,
        roleType: roleType,
      };

      console.log("LOGIN REQUEST:", request);

      const response = await axios.post(
        `${API.V2}/pgOwner/loginPgOwner`,
        request,
      );

      console.log("LOGIN RESPONSE:", response.data);

      // ==========================================
      // CHECK RESPONSE
      // ==========================================

      if (response.data?.statusCode === 200 && response.data?.data) {
        // ==========================================
        // RESPONSE USER DATA
        // ==========================================

        const userData = response.data.data;

        // ==========================================
        // EXTRACT JWT
        // ==========================================

        const jwtToken = userData?.jwtToken?.jwtToken || "";

        const expiresIn = userData?.jwtToken?.expiresIn || 0;

        // ==========================================
        // CREATE USER OBJECT
        // ==========================================

        const user = {
          emailId: userData?.emailId || "",

          jwtToken: jwtToken,

          expiresIn: expiresIn,

          pgName: userData?.pgName || "",

          roleType: userData?.roleType || roleType,

          userId: userData?.userId || null,

          userName: userData?.userName || "",
        };

        // ==========================================
        // STORE COMPLETE USER OBJECT
        // ==========================================

        localStorage.setItem("user", JSON.stringify(user));

        // ==========================================
        // STORE INDIVIDUAL VALUES
        // ==========================================

        localStorage.setItem("jwtToken", jwtToken);

        localStorage.setItem("emailId", userData?.emailId || "");

        localStorage.setItem("pgName", userData?.pgName || "");

        localStorage.setItem("roleType", userData?.roleType || roleType);

        localStorage.setItem("userId", userData?.userId || "");

        localStorage.setItem("userName", userData?.userName || "");

        // ==========================================
        // SUCCESS MESSAGE
        // ==========================================

        setSuccessMessage(response.data?.message || "Login Successfully Done!");

        console.log("USER DATA STORED SUCCESSFULLY");

        console.log("USER:", user);

        // ==========================================
        // ROLE BASED NAVIGATION
        // ==========================================

        const loggedInRole = userData?.roleType || roleType;

        setTimeout(() => {
          switch (loggedInRole) {
            case "PG_OWNER":
              navigate("/dashboard");
              break;

            case "APP_ADMIN":
              navigate("/applicationHeadDashboard");
              break;

            case "APP_EXECUTOR":
              navigate("/appExecutorDashboard");
              break;

            case "USER":
              navigate("/usersDashboardPage");
              break;

            default:
              navigate("/");
              break;
          }
        }, 500);
      } else {
        // ==========================================
        // LOGIN FAILED
        // ==========================================

        setErrorMessage(response.data?.message || "Invalid email or password");
      }
    } catch (error) {
      console.error("LOGIN ERROR:", error);

      setErrorMessage(
        error?.response?.data?.message ||
          "Login failed. Please check your email and password.",
      );
    } finally {
      setLoading(false);
    }
  };

  // ==========================================
  // JSX
  // ==========================================

  return (
    <>
      <style>{`

        /* ==========================================
           GLOBAL
        ========================================== */

        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          padding: 0;
          font-family: "Segoe UI", Arial, sans-serif;
        }

        /* ==========================================
           LOGIN PAGE
        ========================================== */

        .login-page {
          min-height: 100vh;
          width: 100%;

          display: flex;
          align-items: center;
          justify-content: center;

          padding: 30px;

          background-image:
            linear-gradient(
              rgba(8, 18, 35, 0.68),
              rgba(8, 18, 35, 0.68)
            ),
            url("https://images.unsplash.com/photo-1520277739336-7bf67edfa768?auto=format&fit=crop&w=2000&q=85");

          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }

        /* ==========================================
           MAIN CONTAINER
        ========================================== */

        .login-container {
          width: 100%;
          max-width: 1050px;
          min-height: 620px;

          display: grid;
          grid-template-columns: 1fr 1fr;

          overflow: hidden;

          background: rgba(255, 255, 255, 0.97);

          border-radius: 24px;

          box-shadow:
            0 25px 70px rgba(0, 0, 0, 0.35);
        }

        /* ==========================================
           LEFT SIDE
        ========================================== */

        .login-left {
          display: flex;
          flex-direction: column;
          justify-content: center;

          padding: 55px;

          color: white;

          background:
            linear-gradient(
              rgba(11, 37, 69, 0.84),
              rgba(11, 37, 69, 0.84)
            );
        }

        .brand-title {
          font-size: 44px;
          font-weight: 800;

          letter-spacing: 1px;

          margin-bottom: 8px;
        }

        .brand-subtitle {
          font-size: 18px;

          opacity: 0.9;

          margin-bottom: 40px;
        }

        .welcome-title {
          font-size: 32px;

          font-weight: 700;

          margin-bottom: 15px;
        }

        .welcome-text {
          max-width: 430px;

          font-size: 16px;

          line-height: 1.7;

          opacity: 0.88;
        }

        .feature-list {
          list-style: none;

          padding: 0;

          margin-top: 35px;
        }

        .feature-list li {
          margin-bottom: 15px;

          font-size: 15px;
        }

        .feature-list li::before {
          content: "✓";

          margin-right: 10px;

          font-weight: bold;
        }

        /* ==========================================
           RIGHT SIDE
        ========================================== */

        .login-right {
          display: flex;

          align-items: center;
          justify-content: center;

          padding: 45px;

          background: white;
        }

        .login-form {
          width: 100%;

          max-width: 410px;
        }

        .login-heading {
          font-size: 30px;

          font-weight: 700;

          color: #172033;

          margin-bottom: 8px;
        }

        .login-description {
          font-size: 14px;

          color: #777;

          margin-bottom: 30px;
        }

        /* ==========================================
           ROLE
        ========================================== */

        .role-title {
          font-size: 14px;

          font-weight: 600;

          color: #444;

          margin-bottom: 10px;
        }

        .role-container {
          width: 100%;

          display: flex;

          gap: 8px;

          margin-bottom: 28px;
        }

        .role-button {
          flex: 1;

          border: 1px solid #d7dce5;

          background: #f8f9fb;

          color: #555;

          padding: 11px 6px;

          border-radius: 9px;

          font-size: 12px;

          font-weight: 600;

          cursor: pointer;

          white-space: nowrap;

          transition: all 0.2s ease;
        }

        .role-button:hover {
          border-color: #1769aa;

          color: #1769aa;
        }

        .role-button.active {
          background: #1769aa;

          border-color: #1769aa;

          color: white;

          box-shadow:
            0 4px 12px
            rgba(23, 105, 170, 0.25);
        }

        /* ==========================================
           INPUT
        ========================================== */

        .input-group {
          margin-bottom: 24px;
        }

        .input-label {
          display: block;

          font-size: 14px;

          font-weight: 600;

          color: #444;

          margin-bottom: 9px;
        }

        .input-wrapper {
          position: relative;
        }

        .login-input {
          width: 100%;

          height: 46px;

          padding: 12px 15px;

          border: 1px solid #d7dce5;

          border-radius: 9px;

          font-size: 14px;

          outline: none;

          transition: 0.2s;
        }

        .login-input:focus {
          border-color: #1769aa;

          box-shadow:
            0 0 0 3px
            rgba(23, 105, 170, 0.08);
        }

        .password-input {
          padding-right: 45px;
        }

        .password-toggle {
          position: absolute;

          right: 13px;

          top: 50%;

          transform: translateY(-50%);

          border: none;

          background: transparent;

          cursor: pointer;

          font-size: 17px;

          color: #777;

          padding: 3px;
        }

        /* ==========================================
           ERROR
        ========================================== */

        .error-message {
          background: #fff1f1;

          color: #d93025;

          border: 1px solid #ffd0d0;

          padding: 11px 13px;

          border-radius: 8px;

          font-size: 13px;

          margin-bottom: 18px;
        }

        /* ==========================================
           SUCCESS
        ========================================== */

        .success-message {
          background: #effaf2;

          color: #16803c;

          border: 1px solid #c9efd4;

          padding: 11px 13px;

          border-radius: 8px;

          font-size: 13px;

          margin-bottom: 18px;
        }

        /* ==========================================
           LOGIN BUTTON
        ========================================== */

        .login-button {
          width: 100%;

          height: 46px;

          border: none;

          background: #1769aa;

          color: white;

          padding: 12px;

          border-radius: 9px;

          font-size: 15px;

          font-weight: 700;

          cursor: pointer;

          transition: all 0.2s ease;

          margin-top: 4px;
        }

        .login-button:hover {
          background: #0f568f;

          transform: translateY(-1px);
        }

        .login-button:disabled {
          background: #9db9cf;

          cursor: not-allowed;

          transform: none;
        }

        /* ==========================================
           FORGOT PASSWORD
        ========================================== */

        .forgot-password-wrapper {
          text-align: center;

          margin-top: 20px;

          margin-bottom: 20px;
        }

        .forgot-password {
          border: none;

          background: none;

          color: #1769aa;

          font-size: 13px;

          cursor: pointer;

          padding: 0;
        }

        .forgot-password:hover {
          text-decoration: underline;
        }

        /* ==========================================
           PG REGISTRATION
        ========================================== */

        .register-section {
          text-align: center;

          padding-top: 18px;

          border-top: 1px solid #eeeeee;

          margin-top: 4px;
        }

        .register-text {
          color: #666;

          font-size: 13px;

          margin: 0 0 7px 0;
        }

        .register-button {
          border: none;

          background: transparent;

          color: #1769aa;

          font-size: 14px;

          font-weight: 700;

          cursor: pointer;

          padding: 2px 0;
        }

        .register-button:hover {
          text-decoration: underline;

          color: #0f568f;
        }

        /* ==========================================
           TABLET
        ========================================== */

        @media (max-width: 850px) {

          .login-container {
            grid-template-columns: 1fr;

            max-width: 500px;
          }

          .login-left {
            display: none;
          }

          .login-right {
            padding: 40px 30px;
          }

        }

        /* ==========================================
           MOBILE
        ========================================== */

        @media (max-width: 500px) {

          .login-page {
            padding: 15px;
          }

          .login-container {
            border-radius: 18px;
          }

          .login-right {
            padding: 30px 20px;
          }

          .login-heading {
            font-size: 26px;
          }

          .role-container {
            gap: 5px;
          }

          .role-button {
            font-size: 10px;

            padding: 10px 4px;
          }

        }

      `}</style>

      <div className="login-page">
        <div className="login-container">
          {/* ========================================
              LEFT SIDE
          ======================================== */}

          <div className="login-left">
            <div className="brand-title">SVK PG</div>

            <div className="brand-subtitle">PG Management System</div>

            <div className="welcome-title">Welcome Back!</div>

            <div className="welcome-text">
              Manage your PG, rooms, beds, tenants, payments and daily
              operations from one secure platform.
            </div>

            <ul className="feature-list">
              <li>Room & Bed Management</li>

              <li>Tenant Management</li>

              <li>Payment Management</li>

              <li>Food Menu Management</li>
            </ul>
          </div>

          {/* ========================================
              RIGHT SIDE
          ======================================== */}

          <div className="login-right">
            <form className="login-form" onSubmit={handleLogin}>
              <div className="login-heading">Login</div>

              <div className="login-description">
                Sign in to continue to SVK PG Management
              </div>

              {/* ====================================
                  ROLE SELECTION
              ==================================== */}

              <div className="role-title">Login As</div>

              <div className="role-container">
                {roles.map((role) => (
                  <button
                    key={role.value}
                    type="button"
                    className={`role-button ${
                      roleType === role.value ? "active" : ""
                    }`}
                    onClick={() => setRoleType(role.value)}
                  >
                    {role.label}
                  </button>
                ))}
              </div>

              {/* ====================================
                  EMAIL
              ==================================== */}

              <div className="input-group">
                <label className="input-label">Email</label>

                <input
                  type="email"
                  className="login-input"
                  placeholder="Enter your email"
                  value={emailId}
                  onChange={(e) => setEmailId(e.target.value)}
                  autoComplete="username"
                />
              </div>

              {/* ====================================
                  PASSWORD
              ==================================== */}

              <div className="input-group">
                <label className="input-label">Password</label>

                <div className="input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="login-input password-input"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />

                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? "🙈" : "👁️"}
                  </button>
                </div>
              </div>

              {/* ====================================
                  ERROR MESSAGE
              ==================================== */}

              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}

              {/* ====================================
                  SUCCESS MESSAGE
              ==================================== */}

              {successMessage && (
                <div className="success-message">{successMessage}</div>
              )}

              {/* ====================================
                  LOGIN BUTTON
              ==================================== */}

              <button type="submit" className="login-button" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>

              {/* ====================================
                  FORGOT PASSWORD
              ==================================== */}

              <div className="forgot-password-wrapper">
                <button
                  type="button"
                  className="forgot-password"
                  onClick={() => navigate("/forgotPassword")}
                >
                  Forgot Password?
                </button>
              </div>

              {/* ====================================
                  REGISTER - PG ADMIN ONLY
              ==================================== */}

              {roleType === "PG_OWNER" && (
                <div className="register-section">
                  <p className="register-text">
                    Are you a new PG Owner? Please
                  </p>

                  <button
                    type="button"
                    className="register-button"
                    onClick={() => navigate("/pgOwnerRegistration")}
                  >
                    Register Here
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
